import React, { useState, useEffect } from 'react'
import BackgroundImage from "gatsby-background-image"
import { imgOneAnims, imgTwoAnims, imgThreeAnims } from './LandingCarousel.anims';

import { Wrapper, ImageWrapper } from './LandingCarousel.styles'


const LandingCarousel = ({ imageData, carouselPosition }) => {

    const determinePosition = (carouselPosition) => {
        if (carouselPosition === '1' || carouselPosition === '2') {
            return 'end'
        } else return 'beginning'
    }

    return (
        <Wrapper>

            {/* <SplashText text={'testing with some text'} carouselPosition={carouselPosition} /> */}

            <ImageWrapper
                initial={imgThreeAnims.initial}
                variants={imgThreeAnims.variants}
                animate={'beginning'}
            >
                <BackgroundImage Tag="section" backgroundColor={`white`}
                    className={"background"} fluid={imageData['imgLanding3'].childImageSharp.fluid} alt='splash-image-1' />
            </ImageWrapper>
            <ImageWrapper
                initial={imgTwoAnims.initial}
                variants={imgTwoAnims.variants}
                animate={carouselPosition === '2' ? 'end' : 'beginning'}
            >
                <BackgroundImage Tag="section" backgroundColor={`white`}
                    className={"background"} fluid={imageData['imgLanding2'].childImageSharp.fluid} alt='splash-image-2' />
            </ImageWrapper>
            <ImageWrapper
                initial={imgOneAnims.initial}
                variants={imgOneAnims.variants}
                animate={determinePosition(carouselPosition)}
            >
                <BackgroundImage Tag="section" backgroundColor={`white`}
                    className={"background"} fluid={imageData['imgLanding1'].childImageSharp.fluid} alt='splash-image-3' />
            </ImageWrapper>
        </Wrapper>
    )
}


export default LandingCarousel;